export const now = () => new Date(Date.now());
export const dateNow = () => now().getTime();
